<ul>
  <li *ngFor="let segment of segments" class="category-{{ segment.category }}" [class.active]="segment.value > 0">
    <span>{{ segment.value | number:'1.0-1' }}{{ unit }}</span>
    <i title="{{ segment.category | categoryName }}"></i>
    <span *ngIf="showLabels">{{ segment.name }}</span>
  </li>
</ul>
